import { rootPath } from '../../constants/defaults';

function getDefaultRequestConfig() {
  return JSON.parse(
    JSON.stringify({
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;',
      },
    }),
  );
}
function getViewRequestConfig() {
  return JSON.parse(
    JSON.stringify({
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'html;',
      },
    }),
  );
}

async function fetchJSON(url, config) {
  return fetch(url, config).then((response) => {
    if (!response.ok) {
      throw response;
    }
    return response.json();
  });
}

async function fetchView(url, config) {
  return fetch(url, config).then((response) => {
    if (!response.ok) {
      throw response;
    }
    return response.text();
  });
}

export function cartFetch() {
  return fetchJSON(`${rootPath}cart.js`, getDefaultRequestConfig());
}

export function cartPageFetch() {
  return fetchView(`${rootPath}cart?view=content`, getViewRequestConfig());
}

export function cartTableFetch() {
  return fetchView(`${rootPath}cart?view=table`, getViewRequestConfig());
}

export function cartTotalSummaryFetch() {
  return fetchView(`${rootPath}cart?view=total-summary`, getViewRequestConfig());
}

export function cartAddItems(items) {
  const config = getDefaultRequestConfig();

  config.method = 'POST';
  config.body = JSON.stringify({
    items,
  });

  return fetchJSON(`${rootPath}cart/add.js`, config);
}

function getItemIndex(key) {
  if (typeof key !== 'string' || key.split(':').length !== 2) {
    throw new TypeError('Theme Cart: Provided key value is not a string with the format xxx:xxx');
  }

  return cartFetch().then((state) => {
    let index = -1;

    state.items.forEach((item, i) => {
      index = item.key === key ? i + 1 : index;
    });

    if (index === -1) {
      return Promise.reject(new Error('Theme Cart: Unable to match line item with provided key'));
    }

    return index;
  });
}

function cartChange(line, options = {}) {
  const config = getDefaultRequestConfig();

  config.method = 'POST';
  config.body = JSON.stringify({
    line,
    quantity: options.quantity,
    properties: options.properties,
  });

  return fetchJSON(`${rootPath}cart/change.js`, config);
}

export function cartUpdateItem(key, options) {
  return getItemIndex(key).then((line) => cartChange(line, options));
}

export function cartRemoveItem(key) {
  return getItemIndex(key).then((line) => cartChange(line, { quantity: 0 }));
}

export function cartClear() {
  const config = getDefaultRequestConfig();
  config.method = 'POST';

  return fetchJSON(`${rootPath}cart/clear.js`, config);
}

function cartUpdate(body) {
  const config = getDefaultRequestConfig();

  config.method = 'POST';
  config.body = JSON.stringify(body);

  return fetchJSON(`${rootPath}cart/update.js`, config);
}

export function cartUpdateNote(note) {
  return cartUpdate({ note });
}

export function cartClearNote() {
  return cartUpdate({ note: '' });
}

export function cartShippingRates() {
  return fetchJSON(`${rootPath}cart/shipping_rates.json`, getDefaultRequestConfig());
}
